import React from "react";
import { Button } from "./ui/button";
import { MessageSquare, Phone, ArrowRight } from "lucide-react";

const HeroSection = () => {
  const handleWhatsApp = () => {
    window.open("https://wa.me/6588921053?text=Hi, I'd like to book a valet service", "_blank");
  };

  const handleCall = () => {
    window.location.href = "tel:+6588921053";
  };

  return (
    <section className="relative pt-32 pb-24 px-6 overflow-hidden bg-gradient-to-br from-yellow-50 via-amber-50 to-yellow-100">
      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-yellow-300/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-amber-300/20 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full shadow-md mb-8 fade-in">
            <div className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse"></div>
            <span className="text-sm font-semibold text-slate-700">Available 9PM - 4AM Daily</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-slate-900 mb-6 leading-tight slide-in-left">
            Drink, Don't Drive,
            <span className="block text-yellow-600 mt-2">Be Home Safe</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-slate-600 mb-12 leading-relaxed max-w-3xl mx-auto slide-in-right">
            Call us for professional drive home services. Your safety is our priority.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16 fade-in">
            <Button
              onClick={handleWhatsApp}
              size="lg"
              className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold text-lg px-8 py-6 h-auto shadow-xl hover:shadow-2xl w-full sm:w-auto"
            >
              <MessageSquare className="w-5 h-5 mr-2" />
              Book via WhatsApp
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <Button
              onClick={handleCall}
              variant="outline"
              size="lg"
              className="border-2 border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white text-lg px-8 py-6 h-auto w-full sm:w-auto font-semibold"
            >
              <Phone className="w-5 h-5 mr-2" />
              Call Now
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="grid grid-cols-3 gap-8 max-w-3xl mx-auto pt-12 border-t border-slate-300">
            <div className="fade-in">
              <p className="text-3xl font-bold text-yellow-600 mb-2">24/7</p>
              <p className="text-sm text-slate-600">Ready To Respond</p>
            </div>
            <div className="fade-in" style={{animationDelay: '0.1s'}}>
              <p className="text-3xl font-bold text-yellow-600 mb-2">100%</p>
              <p className="text-sm text-slate-600">Safe & Reliable</p>
            </div>
            <div className="fade-in" style={{animationDelay: '0.2s'}}>
              <p className="text-3xl font-bold text-yellow-600 mb-2">Fast</p>
              <p className="text-sm text-slate-600">Response Time</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
